/**
 * Representation of a remote log POST request.
 */
export interface Log {
  type: LogType;
  /**
   * current route (path) in the client app.
   */
  route: string;
  /**
   * Active org id.
   */
  organisationId?: string;
  /**
   * Active user id.
   */
  userId?: string;
  /**
   * Active user email.
   */
  email?: string;
  /**
   * Last http request id.
   */
  requestId?: string;
  /**
   * Active user session.
   */
  sessionId?: string;
  /**
   * For http request logs, the response time in milliseconds.
   */
  responseTime?: number;
  /**
   * For http request logs, the endpoint.
   */
  apiPath?: string;
  /**
   * For http request logs, the api method.
   */
  apiVerb?: string;
}

/**
 * The type of log reported.
 */
export enum LogType {
  /**
   * Timing log of http request resolution.
   */
  HttpLog = 'HTTP-LOG',
  Error = 'ERROR',
  Info = 'INFO'
}
